import { Directive, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: '[autotrim]' })
export class AutotrimDirective {
  constructor() {
    const ngControl = inject(NgControl);

    const valueAccessor = ngControl.valueAccessor!;
    const { registerOnChange } = valueAccessor;
    valueAccessor.registerOnChange = (fn: any) =>
      registerOnChange.call(valueAccessor, (value: any) => {
        const trimmedValue = typeof value === 'string' ? value.trim() : value;
        return fn(trimmedValue);
      });
  }
}
